import { render, staticRenderFns } from "./QDataTableHeader.vue?vue&type=template&id=bd84defc&scoped=true&"
import script from "./QDataTableHeader.vue?vue&type=script&lang=js&"
export * from "./QDataTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./QDataTableHeader.vue?vue&type=style&index=0&id=bd84defc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd84defc",
  null
  
)

export default component.exports